import React, { Component } from "react";
import { connect } from "react-redux";
import { getAlimentsSimple } from "../les-tabs-ducks/Aliments.ducks";
import { getDiversification } from "../../../../../ReactConst";
import Img from "react-image";
import _ from "lodash";
import loadable from "@loadable/component";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const reqSvgs = require.context(
  "../../../../../styles/img/aliments-new",
  true,
  /\.svg$/
);
const paths = reqSvgs.keys();
const svgs = paths.map((path) => reqSvgs(path));
class Aliments extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.kidItem)) {
      this.props.getAlimentsSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (
      !_.isEmpty(this.props.kidItem) &&
      prevProps.kidItem !== this.props.kidItem
    ) {
      this.props.getAlimentsSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id
      );
    }
  }
  render() {
    let { dataAliments } = this.props;
    console.log("dataAliments", dataAliments);
    return (
      <div
        className="tab-pane show active "
        id="aliments-pane"
        role="tabpanel"
        aria-labelledby="aliments-tab"
      >
        {this.props.loading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.loading}
            />
          </div>
        ) : (
          <div className="content p-0">
            <section className="content-section">
              <div className="text-center">
                {!_.isEmpty(dataAliments) &&
                !_.isEmpty(dataAliments.etatDiversification) ? (
                  <div className="btn-white btn-border text-uppercase mb-4">
                    {"Diversification " +
                      getDiversification(dataAliments.etatDiversification)}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="bloc-recap blue text-center mb-4">
                <div className="title">Aliments déjà introduits</div>
                <div className="d-flex row pt-4 align-items-center justify-content-center ">
                  {!_.isEmpty(dataAliments) &&
                    !_.isEmpty(dataAliments.introduits) ? (
                    dataAliments.introduits.map((Aliment, index) => {
                      var phrase = Aliment.urlPicto;
                      var myRegexp = /aliments\/(.*)/;
                      var match = myRegexp.exec(phrase);
                      let str = match[1];

                      let nameOfImg = _.isEmpty(str) ? "" : str;

                      let exactUrl = svgs.find((url) =>
                        url.includes(nameOfImg)
                      );
                      return (
                        <div key={index} className="col-md-3">
                          <div className="aliment">
                            <Img
                              src={exactUrl ? exactUrl : ""}
                              className="img-fluid"
                              alt=""
                            />
                            <p>{Aliment.libelle}</p>
                          </div>
                        </div>
                      );
                    })) : (
                      <div className="aliment d-grid column align-items-center ">
                            <Img
                            src= {require("../../../../../styles/img/aucun-aliment.svg")}
                              className="img-fluid"
                              alt=""
                            />
                            <p>Aucun aliment introduit </p>
                          </div>
                    )}
                </div>
              </div>
              <div className="bloc-recap red text-center mb-4">
                <div className="title">Aliments interdits</div>
                <div className="d-flex row pt-4 align-items-center justify-content-center">
                  {!_.isEmpty(dataAliments) &&
                    !_.isEmpty(dataAliments.interdits) ? (
                    dataAliments.interdits.map((AlimentInterdits, index) => {
                      var phrase = AlimentInterdits.urlPicto;
                      var myRegexp = /aliments\/(.*)/;
                      var match = myRegexp.exec(phrase);
                      let str = match[1];

                      let nameOfImg = _.isEmpty(str) ? "" : str;
                      let exactUrl = svgs.find((url) =>
                        url.includes(nameOfImg)
                      );
                      return (
                        <div key={index} className="col-md-3">
                          <div className="aliment">
                            <Img src={exactUrl} className="img-fluid" alt="" />
                            <p>{AlimentInterdits.libelle}</p>
                          </div>
                        </div>
                      );
                    })) : (
                      <div className="aliment d-grid column align-items-center">
                            <Img
                              src= {require("../../../../../styles/img/aucun-aliment.svg")}
                              className="img-fluid"
                              alt=""
                            />
                            <p>Aucun aliment interdit</p>
                          </div>
                    )}
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataAliments: state.ficheEnfant.Aliments.data,
  loading: state.ficheEnfant.Aliments.loading,
});
export default connect(mapStateToProps, { getAlimentsSimple })(Aliments);
